import { RegionId } from "./generated/enums"
import { param } from "./generated/labels"
import { HoldingUserRole } from "./permissions/holding/api"
import { ITown } from "./town"
import { RoleId } from "./user"

export interface IRegion {
    RegionId: number
    name: string
}

export interface IBusiness {
    BusinessId: number
    Name: string
}

export interface IHolding {

    HoldingId: number;
    TradingName: string;
    AccountNumber: string;

    Address: string;
    TownId: number;
    Town: ITown;

    WeatherStationId?: number;

    Region: RegionId;

    BusinessId: number;
    Business: IBusiness;

    PermissionsBasedOnServices?: boolean
    Services?: HoldingServices

    AgronomistId?: number

    NVZ: boolean;

    CropYears: IHoldingCropYear[];

    Satellite?: HoldingSatelliteOptions
    SoilManagementPlan?: boolean

    PSorpCapacity?: number

}

export interface IHoldingCropYear {
    YearId: number;
    TotalArea?: number;
    GrasslandDerogationNumber?: string;
    PkModel?: "ADAS" | "SRUC";
}

export interface HoldingUser {
    UserId: number
    FirstName: string
    LastName: string
    Email: string
    Role: RoleId
    HoldingRole: HoldingUserRole
}

export interface HoldingSatelliteOptions {
    enabled: boolean
    indices: {
        ndvi: boolean
    }
}

export interface HoldingServices {

    /** Access Plus */
    AccessPlus?: boolean

    /** Field manager (legacy ame) */
    Omnia?: boolean

    /** Field manager plus (legacy ame) */
    OmniaPlus?: boolean

    /** Business manager (legacy name) */
    Precision?: boolean

    Manure?: boolean

    HealthySoils?: boolean

    Connect?: boolean

    SoilManagementPlan?: boolean

}

export function getHoldingFilter(text: string): ((item: IHolding) => boolean) {

    var re = new RegExp(text, "i");

    return (item: IHolding) => {

        if (item) {
            if (item.TradingName && item.TradingName.match(re)) return true;
            if (item.AccountNumber && item.AccountNumber.match(re)) return true;
            if (item.HoldingId.toString() == text) return true;
        }
    };

}

export function getBusinessList() {

    return param.BusinessId().map(b => ({
        BusinessId: b.value,
        Name: b.text
    }) as IBusiness)
}
